// extracted by mini-css-extract-plugin
export default {"wrap":"filterBlockGenres_wrap__+L-z7","header":"filterBlockGenres_header__2FDUp","genres":"filterBlockGenres_genres__VIuCR"};